/** API client for billing / credit information. */

import { API_BASE } from '../../lib/api-base';

export interface BillingInfo {
  billing_tier: string;
  credits_total: number;
  credits_used: number;
  credits_remaining: number;
  credits_refreshed_at: string | null;
  has_subscription: boolean;
  subscription_status: string | null;
  plan_selected: boolean;
}

export async function fetchBilling(
  aurigaUid: string,
  token: string,
): Promise<BillingInfo> {
  const resp = await fetch(
    `${API_BASE}/api/v1/users/${aurigaUid}/billing`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  if (!resp.ok) {
    const detail = await resp.text().catch(() => 'unknown error');
    throw new Error(`Failed to fetch billing: ${detail}`);
  }
  return resp.json();
}

export async function confirmFreePlan(
  aurigaUid: string,
  token: string,
): Promise<BillingInfo> {
  const resp = await fetch(
    `${API_BASE}/api/v1/users/${aurigaUid}/billing/confirm-free`,
    { method: 'POST', headers: { Authorization: `Bearer ${token}` } },
  );
  if (!resp.ok) {
    const detail = await resp.text().catch(() => 'unknown error');
    throw new Error(`Failed to confirm free plan: ${detail}`);
  }
  return resp.json();
}

export async function createPortalSession(
  aurigaUid: string,
  token: string,
): Promise<string> {
  const resp = await fetch(
    `${API_BASE}/api/v1/users/${aurigaUid}/billing/portal-session`,
    {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  if (!resp.ok) {
    const detail = await resp.text().catch(() => 'unknown error');
    throw new Error(`Failed to create portal session: ${detail}`);
  }
  const data = await resp.json();
  return data.url;
}
